import appLayout from './index.vue'

appLayout.install = function (Vue) {
  Vue.component(appLayout.name, appLayout)
}

export default appLayout
